import React from 'react';

import Meta from '@bizapp-lp/pjb/organisms/Meta';
import { Complete } from '@bizapp-lp/pjb/templates/Complete';

const title =
  'Project Board 無効なページ | 社内外でのプロジェクトを円滑に進めるためのオンラインシェア型プロジェクト進捗管理サービス';
const description =
  'Project Boardは法人向けオンラインシェア型プロジェクト進捗管理サービスです。プロジェクト管理でよく利用されるガントチャート機能やかんばん機能を搭載し、チームや組織、外部ユーザーとのコラボレーションによる業務の効率化をサポートします。';

const Page: React.FC = () => {
  return (
    <>
      <Meta>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
      </Meta>
      <Complete
        heading1="Project Board 無効ページ"
        heading2="無効なページです"
        description="申し訳ありません、こちらのページは無効となっております。"
      />
    </>
  );
};

const Invalid = React.memo(Page);
export default Invalid;
